import { getPlaylistAssignmentsUrl } from '../playlistAssignmentsUtils';
import { useFilteredPlaylistAssignmentsForPortal, usePlaylistAssignmentsParams } from '../playlistAssignmentsHooks';
import PlaylistAssignmentsBlankPage from './PlaylistAssignmentsBlankPage';
import PlaylistAssignmentsForPortalList from './PlaylistAssignmentsForPortalList';
import PlaylistAssignmentsForPortalTable from './PlaylistAssignmentsForPortalTable';
import PlaylistAssignmentsTablePage from './PlaylistAssignmentsTablePage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { usePortal } from '../../portals';
import { NavMarker } from 'react-rhumb';
import { AssignPlaylistButton } from 'academy-common-lib/features/playlistAssignments/components/AssignPlaylistButton';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { ALL_PLAYLISTS_PATH } from '../../myTeam/constants/routes';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentsForPortalCount = ({
  count,
  total
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.playlistAssignments.assignmentsCount",
    options: {
      count,
      total
    }
  });
};
const PlaylistAssignmentsForPortal = ({
  playlistId: propPlaylistId,
  portalId: propPortalId
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    portalId: paramPortalId,
    playlistId: paramPlaylistId
  } = usePlaylistAssignmentsParams();
  const portalId = propPortalId || paramPortalId;
  const playlistId = propPlaylistId || paramPlaylistId;
  const {
    portal,
    portalLoading
  } = usePortal({
    portalId,
    skip: !portalId
  });
  const {
    total,
    playlistAssignmentsForPortal,
    playlistAssignmentsForPortalLoading,
    query
  } = useFilteredPlaylistAssignmentsForPortal({
    playlistId,
    portalId
  });
  const isLoading = portalLoading || playlistAssignmentsForPortalLoading;
  if (!portalId || !playlistId || isLoading) return null;
  if (!total && !(query !== null && query !== void 0 && query.length)) return /*#__PURE__*/_jsx(NavMarker, {
    name: "PLAYLIST_ASSIGNMENTS_LOADED",
    children: /*#__PURE__*/_jsx(PlaylistAssignmentsBlankPage, {
      playlistId: playlistId,
      portalId: portalId
    })
  });
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "PLAYLIST_ASSIGNMENTS_LOADED",
    children: /*#__PURE__*/_jsx(PlaylistAssignmentsTablePage, {
      actions: /*#__PURE__*/_jsxs(Flex, {
        gap: "300",
        overflow: "visible",
        children: [/*#__PURE__*/_jsx(AssignPlaylistButton, {
          playlistId: playlistId,
          portalId: portalId
        }), /*#__PURE__*/_jsx(Button, {
          href: `/academy/${portalId}${ALL_PLAYLISTS_PATH}`,
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlistAssignments.viewAllPlaylistsMyTeam"
          })
        })]
      })
      // do not show back button if not using the routing
      ,
      backButton: paramPortalId ? {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistAssignments.backLink"
        }),
        to: getPlaylistAssignmentsUrl(playlistId)
      } : undefined,
      headerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.assignmentsForPortalHeader",
        options: {
          portalName: portal && portal.companyName || ''
        }
      }),
      searchFilter: FILTER_TYPES.SEARCH_USER,
      tableCount: playlistAssignmentsForPortal && total !== undefined && /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalCount, {
        count: playlistAssignmentsForPortal.length,
        total: total
      }),
      children: isMobile ? /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalList, {
        playlistId: playlistId,
        portalId: portalId
      }) : /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalTable, {
        playlistId: playlistId,
        portalId: portalId
      })
    })
  });
};
export default PlaylistAssignmentsForPortal;